<template>
  <v-card
    tile
    class="mtfont"
  >
    <v-container class="pa-6" id="FormulaPrintArea">
      <v-toolbar dense flat>
        <v-toolbar-title>Formulas</v-toolbar-title>
        <v-text-field
          class="ml-4"
          hide-details
          single-line
          v-model="searchText"
        ></v-text-field>
        <i><v-icon
                v-on:click="runSearch"
        >search</v-icon></i>

        <v-spacer></v-spacer>
        <CsvImportModal/>
        <v-btn
          depressed
          color="black"
          style="color: #fecb39;"
          class="mb-3 mr-3"
          v-on:click="$router.push({name: 'Add'})"
        >+ NEW FORMULA</v-btn>
      </v-toolbar>
    
      <v-simple-table style="border: 1px solid lightgrey;" class="mt-2">
          <template>
            <thead>
              <tr>
                <th v-if="!colors.length">
                  <v-progress-circular
                          indeterminate
                          color="amber"
                  ></v-progress-circular>
                </th>
                <th class="text-left">
                  ACTIONS
                </th>
                <th class="text-left">
                  CODE
                </th>
                <th class="text-left">
                  COLOR
                </th>
                <th class="text-left">
                  NAME
                </th>
                <th class="text-right">
                  <v-btn icon v-on:click="changeCurrentPage(-1)">
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                  <span class="pagination-text">{{currentPage + 1}}/{{colorPages.length}}</span>
                  <v-btn icon v-on:click="changeCurrentPage(1)">
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in colorPages[currentPage]"
                :key="item.code"
              >
                <td width="80px">
                  <table><tr>
                    <td><UpdateColorModal :item="item.code"/></td>
                    <td><v-btn icon small class="ml-1" v-on:click="deleteItem(item.code)"><v-icon>delete</v-icon></v-btn></td>
                  </tr></table>
                  <!-- <v-btn icon small v-on:click="editItem(item.code)"><v-icon>edit</v-icon></v-btn> -->

                  </td>
                <td width="20px">{{ item.code }}</td>
                <td width="20px"> <LighteningBoltIndicater :hexColor="item.hex" /> </td>
                <td>{{ item.name }}</td>
                <td class="text-right"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-row class="mt-2">
          <v-spacer></v-spacer>
        <v-btn icon v-on:click="changeCurrentPage(-1)">
          <v-icon>navigate_before</v-icon>
        </v-btn>
        <span class="pagination-text">{{currentPage + 1}}/{{colorPages.length}}</span>
        <v-btn icon v-on:click="changeCurrentPage(1)">
          <v-icon>navigate_next</v-icon>
        </v-btn>
        </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import LighteningBoltIndicater from '@/components/Admin/LighteningBoltSwatch.vue';
  import UpdateColorModal from '@/components/Admin/ColorUpdateModal.vue';
  import CsvImportModal from '@/components/Admin/CsvImportModal.vue';

  export default {
    name: 'FormulaTable',
    
    components: {
      LighteningBoltIndicater,
      UpdateColorModal,
      CsvImportModal
    },
    data: () => ({
      searchText: '',
      colorModal: true,
      currentPage: 0,
      pages: 1,
      colors: [],
      loadingText: 'Loading...'
    }),
    created() {
      this.$store.dispatch('setAllColors')
              .then(() => { this.colors = this.$store.getters.getAllColors })
              .catch(error => console.error("ERROR", error));
    },
    computed:{
      colorPages() {
        return this.colors.reduce((acc, val, i) => {
          let idx = Math.floor(i / 100);
          let page = acc[idx] || (acc[idx] = []);
          page.push(val);
          return acc;
        }, [])
      }
    },
    methods: {
      changeCurrentPage(value) {
        const newValue = this.currentPage + value;
        if(newValue > -1 && newValue < this.colorPages.length) this.currentPage = newValue;
      },
      runSearch() {
        this.$store.dispatch('searchColor', this.searchText).then(response => {
          this.colors = response.data.colorSearch;
        })
      },
      deleteItem(item) {
        const isDelete = confirm('Delete Pantone ' + item + ' and all of it\'s formula history? This action CANNOT be undone!');
        if(isDelete) {
          this.$store.dispatch('deleteColor', item).then(async response => {
            if (response.status === 200) {
              this.$store.dispatch('setAllColors')
                      .then(() => {
                        this.colors = this.$store.getters.getAllColors;
                      });
            } else (alert('Delete action for color ' + item + ' failed!'));
          });
        }
      },
      editItem(item) {
        window.open('/edit/' + item, "_self");
      },
      printDiv: function() { 
        var divContents = document.getElementById("FormulaPrintArea").innerHTML; 
        var a = window.open('', '', 'height=600, width=900'); 
        a.document.write('<html><body>'); 
        a.document.write(divContents); 
        a.document.write('</body></html>'); 
        a.document.close();
        a.print(); 
        a.close();
      }
    }
  }
</script>

<style scoped>
.pagination-text {
  color: grey;
  font-size: small;
  padding-top: 8px;
}
</style>